export default __webpack_public_path__ + "img/Oracle-Logo-660x330.1afcb1e6.png";